<div
	data-cy="c-removable-filter-button"
	class="flex justify-between items-center border-secondary-400 rounded-xl border max-h-6 gap-0.5 px-2 py-1"
	[class]="styleClass()"
	[class.text-secondary-400]="disabled()"
>
	<div
		class="select-none text-xs text-ellipsis overflow-hidden whitespace-nowrap"
		[class.text-secondary-800]="!disabled()"
		[class.text-secondary-400]="disabled()"
	>
		<ng-content></ng-content>
	</div>
	@if (!hideRemoveButton()) {
		<button
			class="text-secondary-500 cursor-pointer hover:text-secondary-800 transition outline-none focus-visible:ring-2 focus-visible:ring-focus bg-transparent border-none p-1 flex items-center justify-center h-4.5 w-4.5"
			data-cy="ui-removable-filter-button-deselect"
			[tabindex]="tabIndex()"
			(click)="removeClick.emit()"
		>
			<ui-icon icon="x_cross" size="s"></ui-icon>
		</button>
	}
</div>
